module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY9.f8c3d0fd.jpg";